// Import this properly, currently duplicated
function closeMenu() {
 d3.select('nav').classed('open', false);
 d3.select('.nav__logo').attr('src', '/wp-content/themes/accelered/static/UMGC_ID_NEG_031422_1500.svg')
 d3.select('#mobile-menu-button-js #top-bar').transition()
   .attr('y', "0")
   .attr('transform', 'rotate(0)')
 d3.select('#mobile-menu-button-js #bottom-bar').transition()
   .attr('y', "60")
   .attr('transform', 'rotate(0)')
 d3.select('#mobile-menu-button-js #middle-bar').transition()
   .attr('height', 5)
}

function openSubNav(event) {
	closeSubNav();
	let index = d3.select(this).attr("data-index");
	let matchedNav = d3.select('.subnav[data-index="' + index + '"')

	matchedNav.select('.subnav__links-outer-wrap').style('left', this.getBoundingClientRect().x + 'px')
	
	matchedNav.classed('subnav--open', true);
}

function closeSubNav() {
	d3.selectAll('.subnav').classed('subnav--open', false);
}

function closeNave(argument) {
	// body...
}

d3.selectAll('.top-nav .nav-link').on("mouseenter", closeSubNav);
d3.selectAll('.has-subnav-js').on("mouseenter", openSubNav);

document.querySelector("nav").addEventListener("mouseleave", closeSubNav);

d3.selectAll('.nav-link--sub').on("click", closeMenu);